'use strict';

var debounce = require('lodash/debounce');

var VALID_TRAVEL_TYPES = ['round', 'oneway'];

var safeTravelType = function (type) {
    return VALID_TRAVEL_TYPES.indexOf(type) !== -1 ? type : 'round';
};

var sharedState = require('./awardConversionBanner/sharedState');
var $cache = sharedState.$cache;

var commonFeatures = require('./awardConversionBanner/commonFeatures');
var airportsFeatures = require('./awardConversionBanner/airportsFeatures');
var travelDatesFeatures = require('./awardConversionBanner/travelDatesFeatures');
var passengersFeatures = require('./awardConversionBanner/passengersFeatures');
var territorialFeatures = require('./awardConversionBanner/territorialContinuityFeatures');

const init = () => {
    // Recover last flight search data, if available
    let lastFlightSearchData = localStorage.lastFlightSearchData;
    if (lastFlightSearchData) {
        sharedState.debug('lastFlightSearchData', lastFlightSearchData);
        lastFlightSearchData = JSON.parse(lastFlightSearchData);

        $cache.tripDeparture.attr('data-airport', lastFlightSearchData.departure);
        airportsFeatures.fillAirportInput($cache.tripDeparture);

        $cache.tripDestination.attr('data-airport', lastFlightSearchData.destination);
        airportsFeatures.fillAirportInput($cache.tripDestination);

        $cache.tripDateStart.attr('data-travel-date', lastFlightSearchData.startDate);
        travelDatesFeatures.fillDatesInput($cache.tripDateStart);

        $cache.tripPassengers.attr('data-passengers', lastFlightSearchData.passengers);
        passengersFeatures.updatePassengersInput();

        if (lastFlightSearchData.returnDate) {
            $cache.tripDateEnd.attr('data-travel-date', lastFlightSearchData.returnDate);
            travelDatesFeatures.fillDatesInput($cache.tripDateEnd);
        }

        setTimeout(() => {
            $(`input[type=radio][name=travelType][value=${safeTravelType(lastFlightSearchData.type)}]`).trigger('click');
        }, 100);

        localStorage.lastFlightSearchData = '';
        delete localStorage.lastFlightSearchData;
    }

    // Init on load
    commonFeatures.syncInputsState();

    // Wire syncInputsState to resize event
    $(window).on('resize', debounce(commonFeatures.syncInputsState, 250));

    // Handle Travel Type Changes
    $('input[type=radio][name=travelType]').on('change', function(e) {
        let newTravelType = commonFeatures.getCurrentTravelType();
        if (newTravelType === 'oneway') {
            $cache.tripDateEnd.hide();
        } else {
            $cache.tripDateEnd.show();
        }
        if ($cache.litepicker) {
            $cache.litepicker.setOptions({
                singleMode: newTravelType === 'oneway'
            });
        }
        $cache.mainWrapper.trigger('form:validityCheck');
    });

    $cache.mainWrapper.on('form:validityCheck', (e) => {
        airportsFeatures.checkInputsValidity(true);
        travelDatesFeatures.checkInputsValidity(true);
    });

    // [RefX] Fetch territorial config via AJAX to bypass Page Designer cache
    var settings = $cache.mainWrapper.data('settings');
    if (settings && settings.territorialConfigURL) {
        $.getJSON(settings.territorialConfigURL).done(function (data) {
            if (data.config) {
                window.ITA_RefX_TerritorialConfig = data.config;
                window.ITA_RefX_TerritorialLabels = data.labels || {};
                window.ITA_RefX_TerritorialLocale = data.locale || 'it_IT';
                window.ITA_RefX_TerritorialIcons = data.icons || {};
                if (data.contentAssets && Object.keys(data.contentAssets).length > 0) {
                    var $container = $('#hidden-territorial-assets');
                    if (!$container.length) {
                        $container = $('<div id="hidden-territorial-assets" style="display:none;" aria-hidden="true"></div>');
                        $cache.body.append($container);
                    }
                    Object.keys(data.contentAssets).forEach(function (assetId) {
                        var safeId = String(assetId).replace(/[^a-zA-Z0-9_-]/g, '');
                        $container.append($('<div id="asset-' + safeId + '">').html(data.contentAssets[assetId]));
                    });
                }
            }
        });
    }
};

const initCaching = () => {
    // Init Cache
    $cache.body = $('body');
    $cache.mainWrapper = $('.award-search');
    $cache.searchFlightsButton = $cache.mainWrapper.find('.award-search__apply-button');
    
    // [RefX] Cache the hidden input
    $cache.isRefX = $('#isRefX');
    
    $cache.tripDeparture = $('#tripDeparture');
    $cache.tripDestination = $('#tripDestination');
    $cache.tripDateStart = $('#tripDateStart');
    $cache.tripDateEnd = $('#tripDateEnd');
    $cache.tripPassengers = $('#tripPassengers');

    $cache.popupSearchAirport = $('.popup-search-airport');
    $cache.popupTravelDate = $('.popup-travel-date');
    $cache.popupPassengers = $('.popup-travel-passengers');
    $cache.popupLogin = $('.popup-login');
    $cache.popupError = $('.popup-error');

    $cache.airportItemToClone = $('.clones-wrapper .airport-result-item');
    $cache.popupSearchAirportResults = $cache.popupSearchAirport.find('.popup-search-airport__results');
    $cache.tripDestinationWrapper = $('.award-search__trip-destination');
    $cache.tripDatesWrapper = $('.award-search__trip-dates');

    $cache.travelDateApplyButton = $cache.popupTravelDate.find('.popup-travel-date__apply-button');
    $cache.titleDateDeparture = $cache.popupTravelDate.find('.dateDeparture');
    $cache.titleDateReturn = $cache.popupTravelDate.find('.dateReturn');

    $cache.adultPassengers = $cache.popupPassengers.find('input[name="passengers-adult"]');
    $cache.childPassengers = $cache.popupPassengers.find('input[name="passengers-child"]');
    $cache.babyPassengers = $cache.popupPassengers.find('input[name="passengers-baby"]');
    $cache.passengersApplyButton = $cache.popupPassengers.find('.popup-travel-passengers__apply-button');
    $cache.loginButton = $cache.popupLogin.find('.popup-login__login-button');

    $cache.litepicker = null;
};

const getSearchData = () => {
    let departure = JSON.parse($cache.tripDeparture.attr('data-airport'));
    let destination = JSON.parse($cache.tripDestination.attr('data-airport'));
    let startDate = JSON.parse($cache.tripDateStart.attr('data-travel-date'));
    let returnDate = null;
    let passengers = JSON.parse($cache.tripPassengers.attr('data-passengers'));
    let type = commonFeatures.getCurrentTravelType();

    // [RefX] Read the value from the hidden input
    let isRefX = $cache.isRefX.val() === 'true';

    try {
        returnDate = JSON.parse($cache.tripDateEnd.attr('data-travel-date'));
    } catch (error) {
        // Nothing to do ...
    }

    let searchData = {
        departure: JSON.stringify(departure),
        destination: JSON.stringify(destination),
        startDate: JSON.stringify(startDate),
        returnDate: returnDate ? JSON.stringify(returnDate) : null,
        passengers: JSON.stringify(passengers),
        type: type,
        isRefX: isRefX
    };

    return searchData;
};

const searchButtonHandler = () => {
    // Handle Search Button
    $cache.searchFlightsButton.on('click', () => {

        let isFormReady = true;

        [airportsFeatures, travelDatesFeatures].forEach((moduleItem) => {
            isFormReady = moduleItem.checkInputsValidity() && isFormReady;
        });

        if (!isFormReady) {
            // Invalid form. Abort ...
            return;
        }

        const settings = $cache.mainWrapper.data('settings');

        let searchData = getSearchData();

        if (searchData.isRefX && window.ITA_RefX_TerritorialConfig) {
            var isAuthenticated = $('.customer-containe').length > 0;

            if (!isAuthenticated) {
                executeSearchAjax(searchData);
                return;
            }

            var matchedRule = territorialFeatures.checkRoutes(searchData, window.ITA_RefX_TerritorialConfig);
            
            if (matchedRule) {
                territorialFeatures.openModal(matchedRule, searchData, executeSearchAjax);
                return;
            }
        }
        executeSearchAjax(searchData);
    });
};

const executeSearchAjax = (searchData) => {
    const settings = $cache.mainWrapper.data('settings');
    $.spinner().start();

    $.ajax({
        type: 'POST',
        url: settings.buildURL,
        data: searchData,
        timeout: 18000,
        success: (data) => {
            sharedState.debug('searchFlightsButton click', 'success', 'data', data);

            if (data.url && !data.formData) {
                window.open(data.url, '_blank').focus();
            } else if (data.formData && data.url) {
                let $form = $('<form>', {
                    'action': data.url,
                    'method': 'POST'
                });

                Object.keys(data.formData).forEach((key) => {
                    $form.append(jQuery('<input>', {
                        'name': key,
                        'value': data.formData[key],
                        'type': 'hidden'
                    }));
                });

                $cache.body.append($form);
                $form.trigger('submit');
            } else if (data.login) {
                $.spinner().stop();
                $cache.popupLogin.find('.popup-login__login-button').attr('href', data.urls.login);
                $cache.popupLogin.addClass('visible');
            } else if (!data.success && data.message) {
                $.spinner().stop();
                $cache.popupError.find('.popup-error__description').text(data.message);
                $cache.popupError.addClass('visible');
            }
        },
        error: function () {
            $.spinner().stop();
            var msg = (settings && settings.errorServiceUnavailable) ? settings.errorServiceUnavailable : 'The service is temporarily unavailable. Please try again later.';
            $cache.popupError.find('.popup-error__description').text(msg);
            $cache.popupError.addClass('visible');
        },
        complete: function () {
            $.spinner().stop();
        }
    });
};

const productTileHandler = () => {
    // Handle event from product tiles
    $cache.body.on('amadeus:select', (e, data) => {
        sharedState.debug('awardConversionBanner', 'amadeus:select', 'data', data);

        // Scroll to top of the page
        window.scrollTo({top: 0, behavior: 'smooth'});

        // Fill search form
        if (sharedState.airports.departure.length > 0) {
            let departureAirport = sharedState.airports.departure.find((item) => {
                return item.code === data.departure;
            });
            let destinationAirport = sharedState.airports.departure.find((item) => {
                return item.code === data.destination;
            });

            if (departureAirport && destinationAirport) {
                // Update travel type
                $(`input[type=radio][name=travelType][value=${safeTravelType(data.type)}]`).trigger('click');

                // Fill departure
                $cache.tripDeparture.attr('data-airport', JSON.stringify(departureAirport));
                airportsFeatures.fillAirportInput($cache.tripDeparture);

                // Fill destination
                $cache.tripDestination.attr('data-airport', JSON.stringify(destinationAirport));
                airportsFeatures.fillAirportInput($cache.tripDestination);

                // Reset trip dates
                travelDatesFeatures.fillTripDates();

                // Check form validity
                $cache.mainWrapper.trigger('form:validityCheck');

                // only focus for dropout to appear on desktop and tablet
                if (!window.app.isMobile()) {
                    if($(window).scrollTop() === 0) {
                        $cache.tripDeparture.focus();
                    }
                    $(window).on("scroll.amadeusSelect", function () {
                        if ($(window).scrollTop() === 0) {            
                        // Set focus on departure input
                        $cache.tripDeparture.focus();
                        // Remove the scroll event listener
                        $(window).off("scroll.amadeusSelect");
                        }
                    });
                }
            }
        }
    });
};

const handleLoginPopupBehavior = () => {
    // Handle click on dropout
    $cache.popupLogin.on('click', (e) => {
        if ($(e.target).hasClass('ita-popup')) {
            $cache.popupLogin.removeClass('visible');
        }
    });

    // Handle click on close button
    $cache.popupLogin.on('click', '.popup-login__close', (e) => {
        $cache.popupLogin.removeClass('visible');
    });

    $cache.loginButton.on('click', (e) => {
        e.preventDefault();

        let searchData = getSearchData();
        localStorage.lastFlightSearchData = JSON.stringify(searchData);

        const loginURL = $(e.target).attr('href');
        sharedState.debug('loginURL', loginURL);
        window.location.href = loginURL;
    });
};


const handleErrorPopupBehavior = () => {
    // Handle click on dropout
    $cache.popupError.on('click', (e) => {
        if ($(e.target).hasClass('ita-popup')) {
            $cache.popupError.removeClass('visible');
        }
    });

    // Handle click on close button
    $cache.popupError.on('click', '.popup-error__close', (e) => {
        $cache.popupError.removeClass('visible');
    });
};

module.exports = {
    initCaching: initCaching,
    init: init,
    initAirportFeatures: airportsFeatures.init,
    initTravelDatesFeatures: travelDatesFeatures.init,
    initPassengersFeatures: passengersFeatures.init,
    searchButtonHandler: searchButtonHandler,
    productTileHandler: productTileHandler,
    handleLoginPopupBehavior: handleLoginPopupBehavior,
    handleErrorPopupBehavior: handleErrorPopupBehavior,
};
